import React from "react"
import { OperatorsTable } from "./operatorsTable"
import OperatorsStore from "../operatorsStore"
import { Link } from "../../common/components/link"
import { links } from "../../routes"

const CompanyOperators = () => {
    const operators = OperatorsStore.useAll();
    return <div className="card">
        <div className="card-header bg-theme d-flex align-items-center">
            <div className="flex-fill">
                <h3 className="text-white mb-0">Operatori</h3>
            </div>
            <Link to={links.operatorNew} className="btn btn-outline-secondary">
                <i className="fas fa-user-plus me-2" /> Nuovo Operatore
                        </Link>
        </div>
        <div className="card-body">
            <OperatorsTable data={operators ?? []} />
        </div>
    </div>
};

export default CompanyOperators;
